import { render } from "./ResetPasswordDialog.vue?vue&type=template&id=7887bee0&scoped=true"
import script from "./ResetPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ResetPasswordDialog.vue?vue&type=script&lang=js"

import "./ResetPasswordDialog.vue?vue&type=style&index=0&id=7887bee0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7887bee0"]])

export default __exports__